/* eslint-disable no-mixed-operators */
/* eslint-disable react/jsx-pascal-case */
import React from "react";
import RbLabel from "../../../bosch-react/components/label/RbLabel";
import ExpertCard from "./ExpertCard/ExpertCard";
import Helper from "../../../core/libraries/Helper";
import _ from "lodash";
import axios from "axios";
import Experts_Refinement_Country from "./Experts_Refinement_Country";
import Experts_Refinement_BEO from "./Experts_Refinement_BEO";
import {
  ITooltipHostStyles,
  MessageBar,
  ProgressIndicator,
  TooltipHost,
} from "@fluentui/react";
import ExpertEvidenceModal from "./Modal/ExpertEvidenceModal";
import classes from "./ExpertResults.module.scss";
import { IEvidenceResponse, IExpertResponse, IPerson, ISearchExpertsReq, searchExpert } from "../services";
import Error500 from "../../AccessMediator/components/Error500";

interface IProps {
  keyword: string,
  location: any
}
interface IState {
  expertResults: IExpertResponse | undefined;
  searchExpertsReq: ISearchExpertsReq
  isLoading: boolean;
  isShowModal: boolean;
  currentDetailsModal?: IEvidenceResponse;
}

export default class ExpertResults extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      searchExpertsReq: {
        pageSize: 5,
        page: 1,
        q: "",
        country: "None",
        beo_val: "false",
      },
      expertResults: undefined,
      isLoading: false,
      isShowModal: false,
    };
  }

  componentDidMount(): void {
    let parameters: any = new URLSearchParams(this.props.location.search);
    // Keyword
    let keyword = !_.isUndefined(parameters.get("keyword"))
      ? Helper.decodeCustomized(decodeURIComponent(parameters.get("keyword")))
      : "*";
    this.setState((prevState) => ({
      searchExpertsReq: {
        ...prevState.searchExpertsReq,
        q: keyword,
      },
    }));
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    let currentProps = this.props;
    if (currentProps.keyword !== prevProps.keyword) {
      this.setState((prevState) => ({
        searchExpertsReq: {
          ...prevState.searchExpertsReq,
          q: currentProps.keyword,
          page: 1,
          country: "None",
          beo_val: "false",
        },
      }),
        () => this.retrieveExpert()
      );
    }
  }

  componentWillUnmount(): void {
    this.setState({
      searchExpertsReq: {
        pageSize: 5,
        page: 1,
        q: "",
        country: "None",
        beo_val: "false",
      },
    });
  }


  InfoAlert = (content: string) => (
    <MessageBar style={{ fontSize: "1rem", fontFamily: "BoschFont" }}>
      {content}
    </MessageBar>
  );

  render() {
    const {
      expertResults,
      isLoading,
      isShowModal,
      currentDetailsModal,
    } = this.state;
    const total = !!expertResults && expertResults.totalExperts || 0;
    const styles: Partial<ITooltipHostStyles> = {
      root: {
        display: "inline-block",
        fontFamily: "BoschFont",
        fontSize: "1rem",
      },
    };
    const calloutProps = { gapSpace: 0 };
    const tooltipId = "tooltip";
    return (
      <React.Fragment>
        <ExpertEvidenceModal
          titleId={"ExpertEvidenceModal"}
          isModalOpen={isShowModal}
          hideModal={() => this.onHideModal()}
          currentDetailsModal={currentDetailsModal || null}
        />
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12" style={{ height: 90 }}>
              <div className="ms-Grid-col ms-sm10">
                <h3 className={`${classes.panelTitle}`}>Experts</h3>
              </div>
              <div className={`${classes.iconContainer} ms-Grid-col ms-sm2`}>
                <TooltipHost
                  content="People listes in Expertise are identified based on their contribution in Bosch Connect and/or as a BEO."
                  // Give the user more time to interact with the tooltip before it closes
                  closeDelay={1000}
                  id={tooltipId}
                  calloutProps={calloutProps}
                  styles={styles}
                >
                  <i
                    aria-describedby={tooltipId}
                    className={`${classes.questionFrameIcon} rb-ic-questionFrame`}
                    aria-hidden="true"
                  ></i>
                </TooltipHost>
              </div>
            </div>
            {this.state.searchExpertsReq.q === "*" &&
              <div className={`${classes.expertsCol} ms-Grid-col ms-sm12`}>
                {this.InfoAlert("Not support search all experts")}
              </div>
              ||
              !!isLoading && (
                <div
                  className={`${classes.expertsCol} ms-Grid-col ms-sm12`}
                  style={{ padding: "0 2rem" }}
                >
                  <ProgressIndicator
                    className={classes.BoschFont}
                    label="Experts loading"
                    description="Wait, wait..."
                  />
                </div>) ||
              <>
                {!!expertResults && <div className={`${classes.expertsCol} ms-Grid-col ms-sm8 expert-list-col`}>
                  <div className="ms-Grid">
                    <div className="ms-Grid-row">
                      {expertResults.experts != null &&
                        expertResults.experts.length > 0 &&
                        expertResults.experts.map((expert: IPerson, index: any) => (
                          <div
                            className="ms-Grid-col ms-sm12"
                            style={{ marginTop: 10 }}
                            key={index}
                          >
                            <ExpertCard
                              expert={expert}
                              evidenceQuery={this.state.searchExpertsReq.q || ""}
                              onShowEvidence={this.ShowEvidence}
                            ></ExpertCard>
                          </div>
                        ))
                        ||
                        this.InfoAlert("No expert found.")}
                    </div>
                  </div>
                  {
                    this.state.searchExpertsReq.q !== "*" &&
                    <div>
                      {/* Paging */}
                      {Helper.setEmptyArrayIfNull(expertResults?.experts).length >
                        0 && !isLoading ? (
                        <div
                          className="ms-Grid"
                          style={{ margin: 10 }}
                        >
                          <div className="ms-Grid-row ms-textAlignCenter">
                            <div className="ms-Grid-col ms-sm12">
                              {/* Left arrow */}
                              <span
                                title="Previous"
                                className={
                                  "rb-ic rb-ic-back-left" +
                                  (expertResults?.page === 1
                                    ? "-light-gray"
                                    : " pointer")
                                }
                                onClick={() => this.prevPage()}
                              />

                              {/* Page numbers */}
                              {this.renderCurrentPage()}

                              {/* Right arrow */}
                              <span
                                title="Next"
                                className={
                                  "rb-ic rb-ic-forward-right" +
                                  (Helper.setZeroIfNull(expertResults?.page) +
                                    1 >
                                    Math.ceil(
                                      Helper.setZeroIfNull(total) /
                                      expertResults?.pageSize!
                                    )
                                    ? "-light-gray"
                                    : " pointer")
                                }
                                onClick={() => this.nextPage()}
                              />
                              {/* End pagination */}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {!!this.state.isLoading === false && this.renderTotalResults(total)}
                    </div>
                  }
                </div> || <div className={`${classes.expertsCol} ms-Grid-col ms-sm8 expert-list-col`}>
                    <Error500 />
                  </div>}
                <div className="ms-Grid-col ms-sm1 expert-spacer" />
                <div className="ms-Grid-col ms-sm3 expert-refinement-col" style={{ right: "1rem" }}>
                  <div className="ms-Grid" style={{ marginBottom: "1.5rem" }}>
                    <div className="ms-Grid-row">
                      {/* <Experts_Refinement_NumberOfResults isLoading={isLoading} onChange={this.onChangeNumberResults} /> */}
                      <Experts_Refinement_Country
                        countries={"None"}
                        onChange={this.onChangeCountry}
                        isLoading={isLoading}
                      />
                      <Experts_Refinement_BEO
                        isOnlyBEO={this.state.searchExpertsReq.beo_val === "true"}
                        isLoading={this.state.isLoading}
                        onChange={this.onChangeBEO}
                      />
                    </div>
                  </div>
                </div>
              </>}
          </div>
        </div>
      </React.Fragment >
    );
  }

  onChangeNumberResults = (selectedItem: number) => {
    this.setState((prevState) => ({
      searchExpertsReq: {
        ...prevState.searchExpertsReq,
        limit: selectedItem,
      },
    }), () => {
      this.retrieveExpert()
    });

  };

  onChangeCountry = (selectedCountry: string) => {
    console.log(selectedCountry)
  };

  onChangeBEO = (isBEO: boolean) => {
    this.setState((prevState) => ({
      searchExpertsReq: {
        ...prevState.searchExpertsReq,
        beo_val: isBEO ? "true" : "false",
      },
    }), () => {
      this.retrieveExpert()
    });
  };

  onHideModal = () => {
    this.setState({
      isShowModal: false,
    });
  };
  instance = axios.create({
    headers: {
      "content-type": "application/json",
      KeyId: process.env.REACT_APP_EXPERTS_SERVICE_API_KEY,
    },
  });

  retrieveExpert = async () => {
    const { searchExpertsReq } = this.state;

    // Avoid making a request with "*" to prevent a 504 error
    if (searchExpertsReq.q === "*") return;

    this.setState({ isLoading: true });

    try {
      let expertResponse = await searchExpert(this.state.searchExpertsReq);
      !!expertResponse && this.setState({
        expertResults: !!expertResponse.error && expertResponse.error !== "" ? undefined : expertResponse,
        isLoading: false
      })
    } catch (error) {
      console.error("Error retrieving expert:", error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  renderTotalResults = (total: number) => {
    const { pageSize } = this.state.searchExpertsReq;
    const marginBottom = !!pageSize && pageSize > 5 ? 60 : 10
    return (
      <div className="ms-Grid"
        style={{ margin: `10px 10px ${marginBottom}px 10px` }}
      >
        <div className="ms-Grid-row ms-textAlignCenter">
          <div className="ms-Grid-col ms-sm12">
            <RbLabel>
              {Helper.setZeroIfNull(total) > 0
                ? Helper.numberWithComma(total) +
                " result" +
                (Helper.setZeroIfNull(total) > 1 ? "s" : "")
                : ""}
            </RbLabel>
          </div>
        </div>
      </div>
    );
  };

  renderCurrentPage = () => {
    const expertResults = this.state.expertResults;
    const startNumber =
      expertResults?.pageSize! * (expertResults?.page! - 1) + 1;
    return (
      !!expertResults && (
        <RbLabel
          style={{
            lineHeight: "3rem",
            padding: "1rem",
            minWidth: "5vw",
            display: "inline-block",
          }}
        >
          {/* limit*page-limit+1 */}
          {startNumber} - {startNumber + expertResults.experts.length - 1}
        </RbLabel>
      )
    );
  };

  prevPage = () => {
    if (this.state.expertResults?.page !== 1) {
      this.setState((prevState) => ({
        searchExpertsReq: {
          ...prevState.searchExpertsReq,
          page: prevState.searchExpertsReq.page! - 1,
        },
      }),
        () => {
          this.retrieveExpert()
        });
    }
  }

  nextPage = () => {
    const isMaxPage =
      Helper.setZeroIfNull(
        this.state.expertResults?.page
      ) +
      1 >
      this.state.expertResults?.totalPages!;
    if (!isMaxPage) {
      this.setState((prevState) => ({
        searchExpertsReq: {
          ...prevState.searchExpertsReq,
          page: prevState.searchExpertsReq.page! + 1,
        },
      }),
        () => {
          this.retrieveExpert()
        });
    }
  }


  ShowEvidence = (expertEvidenceDetails: IEvidenceResponse) => {
    console.log("ShowEvidence", expertEvidenceDetails);
    this.setState({
      isShowModal: true,
      currentDetailsModal: expertEvidenceDetails,
    });
  };
}
